import { render, staticRenderFns } from "./ReportesLector.vue?vue&type=template&id=48a551ac&"
import script from "./ReportesLector.vue?vue&type=script&lang=js&"
export * from "./ReportesLector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports